import React from 'react';
import { PinForm } from '../shared/pin-form';
import { PdfViewer } from "presentation/common";
import { NoRecords } from "../shared/no-records";
import clsx from "clsx";

export const DesktopView = ({ docs, onDownloadDocuments, showErrorMessage }) => {

  return (
    <>
      <div className="flex flex-col h-full w-full overflow-hidden p-4">
        <div className="pb-4 flex justify-between items-center">
          <p className="text-primary text-lg">DOCUMENTOS POR FIRMAR</p>
        </div>
        <main
          className={clsx("h-full w-full flex-1 flex-auto grid gap-4", docs.length === 0 ? 'grid-cols-1' : 'grid-cols-3')}>
          {
            docs.length === 0
              ? <NoRecords />
              : (
                <>
                  <div className="col-span-2">
                    <PdfViewer elements={docs} onDownloadDocuments={onDownloadDocuments} />
                  </div>
                  <PinForm docs={docs} showErrorMessage={showErrorMessage} />
                </>
              )
          }
        </main>
      </div>
    </>
  );
};
